var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckThin = function SvgCheckThin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M981.6 112.2c-23.8-22.8-61.6-22-84.4 1.8L281.3 756.8 104.2 558.7c-22-24.6-59.7-26.7-84.3-4.7s-26.7 59.7-4.7 84.3l220.1 246.2c11.1 12.4 26.8 19.6 43.5 19.9h1c16.3 0 31.8-6.6 43.1-18.4l660.5-689.4c22.8-23.8 22-61.6-1.8-84.4",
    className: "check_thin_svg__checkThin0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckThin);
export default ForwardRef;